<template>
  <v-card class="candidate profile preview">
    <v-card-title class="py-4 px-4" :class="themes.candidate.light.dialogTitle">
      <div>
        <div class="title pb-1">My Profile</div>
        <div :class="themes.candidate.light.mutedText">
          Here you can view your online profile
        </div>
      </div>
      <v-spacer />
      <div class="text-xs-right">
        <v-btn icon flat :color="themes.candidate.light.cancel" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>

    <v-divider />

    <v-progress-linear
      v-if="!profile || !ready"
      :color="themes.candidate.light.loading"
      indeterminate
      class="ma-0"
      :height="5"
    />

    <v-card-text class="px-3" v-else>
      <v-layout align-start row justify-space-between>
        <Documents :profile="profile" :profileQualifications="profileQualifications" />

        <v-tooltip left>
          <v-btn
            slot="activator"
            @click="download"
            :color="themes.client.light.primaryActionButton"
            :loading="downloading"
            small
          >
            <v-icon small left>mdi-file-pdf-box</v-icon>Export
          </v-btn>
          <span>Download PDF</span>
        </v-tooltip>

        <v-spacer />

        <CompletionDetails
          v-if="actionItems"
          :complete="profile.complete"
          :actionItems="actionItems"
        />
      </v-layout>

      <div class="px-5">
        <v-layout row wrap align-center justify-space-between class="py-5">
          <v-flex d-flex xs12>
            <v-layout class="text-xs-center" justify-space-around align-center fill-height wrap row>
              <AvatarAndName :profile="profile" />
              <PersonalDetails :profile="profile" :actionItems="actionItems" />
            </v-layout>
          </v-flex>
        </v-layout>
      </div>

      <div ref="application-profile" class="px-5">
        <Biography :profile="profile" />
        <Experience :profile="profile" :experiences="experiences" />
        <Qualifications
          :qualifications="profileQualifications"
          :actionItems="actionItems"
          :profile="profile"
        />
        <AdditionalInformation :profile="profile" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// Components
import AdditionalInformation from '@/components/candidate/profile/AdditionalInformation'
import AvatarAndName from '@/components/candidate/profile/AvatarAndName'
import Biography from '@/components/candidate/profile/Biography'
import CompletionDetails from '@/components/candidate/profile/CompletionDetails'
import Documents from '@/components/candidate/profile/Documents'
import Experience from '@/components/candidate/profile/Experience'
import PersonalDetails from '@/components/candidate/profile/PersonalDetails'
import Qualifications from '@/components/candidate/profile/Qualifications'

// Helpers
import { mapGetters } from 'vuex'

import { generatedDocumentDownloads } from '@/mixins/generatedDocumentDownloads.js'

export default {
  mixins: [generatedDocumentDownloads],
  components: {
    AdditionalInformation,
    AvatarAndName,
    Biography,
    CompletionDetails,
    Documents,
    Experience,
    PersonalDetails,
    Qualifications,
  },

  created() {
    Promise.all([
      this.$store.dispatch('candidate/actionItems/fetchAll'),
      this.$store.dispatch('candidate/experiences/fetchAll'),
      this.$store.dispatch('candidate/profile/fetch'),
      this.$store.dispatch('candidate/profileQualifications/fetchAll'),
      this.$store.dispatch('disciplines/fetchAll'),
    ])
      .then(() => {})
      .catch(() => {})
      .finally(() => (this.ready = true))
  },

  data() {
    return {
      downloading: false,
      ready: false,
    }
  },

  computed: mapGetters({
    actionItems: 'candidate/actionItems/all',
    email: 'auth/email',
    experiences: 'candidate/experiences/all',
    profile: 'candidate/profile/model',
    profileQualifications: 'candidate/profileQualifications/all',
  }),

  methods: {
    async download() {
      this.downloading = true
      const filename = `${this.profile.firstNames} ${this.profile.lastName}.pdf`

      await this.handleGeneratedDocumentRequest(
        this.$http.get('/candidate/profile.pdf', { responseType: 'blob' }),
        {
          filename,
          pendingMessage: 'Your profile document has been requested. You will receive an email with a download link.',
          errorMessage: 'There was a problem downloading your profile document.',
        }
      )

      this.downloading = false
    },
  },
}
</script>
